import { foundationSnackbarShadowOptions, Snackbar as FoundationSnackbar, } from '@genesislcap/foundation-ui';
import { zeroSnackbarStyles } from './snackbar.styles';
import { zeroSnackbarTemplate } from './snackbar.template';
export const zeroSnackbarShadowOptions = foundationSnackbarShadowOptions;
/**
 * @tagname %%prefix%%-snackbar
 */
export class Snackbar extends FoundationSnackbar {
}
/**
 * The Zero Snackbar
 *
 * @public
 * @remarks
 * HTML Element: \<zero-Snackbar\>
 */
export const zeroSnackbar = Snackbar.compose({
    baseName: 'snackbar',
    shadowOptions: zeroSnackbarShadowOptions,
    styles: zeroSnackbarStyles,
    template: zeroSnackbarTemplate,
});
